import { isDesktop } from '@zola-helpers/client/dist/es/util/responsive';
import { setLocalStorage } from '@zola-helpers/client/dist/es/util/storage';

import { CardShelf } from '~/components/common/cards/CardShelf/CardShelf';
import { VendorCardVendor } from '~/components/common/cards/util/types';
import VendorCard, { VendorCardProps } from '~/components/common/cards/VendorCard/VendorCard';
import { TrackingProductLocation } from '~/util/trackingHelper';

const SideScrollingCardList = ({
  trackingProductLocation,
  cardList,
  getCardProps = () => ({}),
  showVendorType,
}: {
  trackingProductLocation: TrackingProductLocation;
  cardList: VendorCardVendor[];
  getCardProps?: (vendor: VendorCardVendor) => Partial<VendorCardProps>;
} & Partial<VendorCardProps>) => {
  return (
    <CardShelf>
      {cardList.map((vendor, index) => {
        return (
          <VendorCard
            key={vendor.storefrontUuid}
            vendor={vendor}
            position={index + 1}
            showDetails={false}
            showOverlayBadge={false}
            onClick={() => {
              setLocalStorage(
                `inquiry_entrypoint_${vendor.storefrontUuid}`,
                trackingProductLocation
              );
            }}
            showCarousel={isDesktop()}
            trackClick={false}
            showVendorType={showVendorType}
            {...getCardProps(vendor)}
          />
        );
      })}
    </CardShelf>
  );
};

export default SideScrollingCardList;
